<script setup lang="ts">
// TODO: replace the one use of this with <b-alert>

import Banner from "./Banner.vue"

import {computed} from "vue"

const props = withDefaults(
  defineProps<{
    // what I'd like to do, but nullable props are not a thing even in 2.7
    // response: { success: boolean, message: string } | null
    response: any // this is fine.  there are cleaner fixes, but this component is going away anyway.
    show: boolean
  }>(),
  {show: true},
)

const showBanner = computed(() => props.show && bannerMessage.value)
const bannerType = computed(() => props.response?.data.success ? "success" : "danger")
const bannerMessage = computed(() => props.response?.data.message)
</script>

<template>
  <Banner v-show="showBanner" :type="bannerType">
    {{ bannerMessage }}
  </Banner>
</template>
